// 封装本地存储的方法
// const $sha256 = require('js-sha256').sha256
// var commomJs = {
//     transformEnglish (value) {
//         var appKey = '6441dc1357a50b64'
//         var salt = '12345678'
//         var secret = 'Y4JaRNbrApDPbgF1LxHPd8TiHaTuYnS6'
//         var curtime = Math.floor(new Date().getTime() / 1000)
//         var valueInput = value
//         // 为加密的签名做处理，请求传data时还要穿输入的值
//         if (value.length > 20) {
//             valueInput = value.substring(0, 10) + value.length + value.substring(value.length - 10, value.length)
//         }
//         var sign = $sha256(appKey + valueInput + salt + curtime + secret).toString()
//         var data = {
//             q: value,
//             appKey: appKey,
//             salt: salt,
//             from: 'en',
//             to: 'zh-CHS',
//             sign: sign,
//             curtime: curtime,
//             signType: 'v3'
//         }
//         return data
//     }
// }
// export default commomJs

// cookies存储（存、取、删除）
export function getCookiesData (cookieKey) {
    // return Cookies.get(cookieKey)
    return localStorage.getItem(cookieKey)
}

export function setCookiesData (cookieKey, cookieVal) {
    return localStorage.setItem(cookieKey, cookieVal)
}

export function removeCookiesData (cookieKey) {
    return localStorage.removeItem(cookieKey)
}
